


































































import { mapMutations, mapGetters } from 'vuex'
import * as types from '@/store/modules/command/mutation-types'
import { Track } from '@/store/modules/track/types'

export default {
  name: 'CommandBar',
  computed: {
    ...mapGetters(['move', 'routes', 'active', 'showed']),
  },
  methods: {
    distinct: (tracks: Track[]) =>
      tracks
        .reduce((acc: Track[], cur: Track) => {
          if (acc.find(track => track.name === cur.name)) {
            return acc
          }

          return [...acc, cur]
        }, [])
        .sort((a: Track, b: Track) => {
          if (!isNaN(+a.name) || !isNaN(+b.name)) {
            return +a.name - +b.name
          }

          return a.name > b.name ? 1 : a.name < b.name ? -1 : 0
        }),
    toggleTheme: (e: boolean) =>
      localStorage.setItem('theme.dark', e.toString()),
    ...mapMutations({
      updateMove: types.UPDATE_MOVE,
    }),
  },
  // watch: {
  // routes: (e: any) => console.log(e),
  //   '$vuetify.theme.dark': (e: boolean): void =>
  //     localStorage.setItem('theme.dark', e.toString()),
  // },
}
